let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bR3YN")).then(() => parcelRequire('chviU'));